import { render } from "./listitem.vue?vue&type=template&id=86c0a4a4"
import script from "./listitem.vue?vue&type=script&lang=js"
export * from "./listitem.vue?vue&type=script&lang=js"

import exportComponent from "D:\\agents\\RosaPantern\\_work\\127\\s\\EPiUmUWebbar\\Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__